import { TableCell } from '@mui/material';
import moneyFormat from '../functions/moneyFormat';

// pass row object as prop 
const TransactionDataRow = ({ row, count, tableHeader,stickyEnabled }) =>{

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row-apiTable": ""
    }

    return(
        <>
            {/* map logic over all columns in object */}
            {tableHeader.map(el => 
                // apply money format to correct columns  
                el['columnname'] == 'transactionamount' || el['columnname'] == 'interchangeamount' ?
                    row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>None</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                // standard display for all other columns 
                : row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                // standard display for all other columns 
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>          
            )}
        </>
        
    );
}

export default TransactionDataRow; 